import React from "react";
import { useEffect } from "react";
import { redirect } from "react-router-dom";
import { Navigate, useLoaderData } from "react-router";
import { useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import AuthenticationModal from "../components/Layout/AuthenticationModal";
import { RootState } from "../app/store";
import { store } from "../app/store";
import { copySharedPrompt, Prompt } from "../app/promptsSlice";
import { useAppSelector, useAppDispatch } from "../app/hooks";

export const tryPromptLoader = async ({ params }: { params: any }) => {
  const state = store.getState();
  const isAuthenticated = state.authentication.isAuthenticated;
  const userPrompts = state.prompts.userPrompts;
  const { sharedPromptId } = params;

  if (isAuthenticated) {
    debugger;
    try {
      if (sharedPromptId) {
        const existingPrompt = userPrompts.find(
          (userPrompt) => userPrompt.sharedPromptId === sharedPromptId
        );

        if (existingPrompt) {
          return existingPrompt;
        } else {
          const prompt = await store
            .dispatch(copySharedPrompt(sharedPromptId))
            .unwrap();

          return prompt;
        }
      } else {
        redirect("/new");
      }
    } catch (error) {
      console.error("Error in loader:", error);
      throw new Response("Failed to load data", { status: 500 });
    }
  }
  return null;
};

export function TryPromptPage() {
  const { sharedPromptId } = useParams();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [openAuthenticationModal, setOpenAuthenticationModal] =
    React.useState(false);

  const isAuthenticated = useAppSelector(
    (state: RootState) => state.authentication.isAuthenticated
  );
  const isDuplicating = useAppSelector(
    (state: RootState) => state.prompts.isDuplicating
  );

  useEffect(() => {
    if (!isAuthenticated) {
      setOpenAuthenticationModal(true);
    }
  }, [isAuthenticated]);

  const prompt: Prompt = useLoaderData() as Prompt;
  if (prompt) return <Navigate to={`/edit/${prompt.id}`} replace />;

  const handlePostAuthentication = () => {
    setOpenAuthenticationModal(false);
    if (sharedPromptId && !isDuplicating) {
      dispatch(copySharedPrompt(sharedPromptId))
        .unwrap()
        .then((prompt) => {
          navigate(`/edit/${prompt.id}`, { replace: true });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleCloseAuthenticationModal = () => {
    setOpenAuthenticationModal(false);
  };

  return (
    <Grid sx={{ width: "100%" }} container>
      <AuthenticationModal
        open={openAuthenticationModal}
        onAuthentication={handlePostAuthentication}
        onClose={handleCloseAuthenticationModal}
      />
      <Box
        sx={{
          height: `calc(100vh - 64px)`,
          width: "100%",
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    </Grid>
  );
}
